import * as actions from 'constants/actionTypes';
import DocumentModal from 'components/modals/document/DocumentModal';
import PersonModal from 'components/modals/person/PersonModal';
import EventModal from 'components/modals/events/EventModal';
import ProjectModal from 'components/modals/project/ProjectModal';
import CompanyModal from 'components/modals/company/CompanyModal';

export const COLLAPSIBLE_MODAL_COMPONENTS = {
    [actions.OPEN_MODAL_DOCUMENT_VIEW]: DocumentModal,
    [actions.OPEN_MODAL_PERSON]: PersonModal,
    [actions.OPEN_MODAL_EVENT]: EventModal,
    [actions.OPEN_MODAL_PROJECT]: ProjectModal,
    [actions.OPEN_MODAL_COMPANY]: CompanyModal
};

export const COLLAPSIBLE_MODAL_ICONS = {
    [actions.OPEN_MODAL_DOCUMENT_VIEW]: 'doc',
    [actions.OPEN_MODAL_PERSON]: 'user-man',
    [actions.OPEN_MODAL_EVENT]: 'calendar-o',
    [actions.OPEN_MODAL_PROJECT]: 'briefcase',
    [actions.OPEN_MODAL_COMPANY]: 'building'
};

export const COLLAPSIBLE_MODAL_CLASSNAME = {
    [actions.OPEN_MODAL_PERSON]: 'person-modal modal-full',
    [actions.OPEN_MODAL_EVENT]: 'event-modal modal-normal',
    [actions.OPEN_MODAL_PROJECT]: 'project-modal modal-full',
    [actions.OPEN_MODAL_COMPANY]: 'project-modal modal-full',
    [actions.OPEN_MODAL_DOCUMENT_VIEW]: 'modal-document modal-full'
};
